import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-28/task-02";

const task: Slide = {
  titleHtml: "Assign the configurations of a ray tracing simulation to the three consequences.",
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
